export enum ContinuityEscrowOnboardingRoutesEnum {
  Members = 'members',
  Depositor = 'depositor',
  Beneficiary = 'beneficiary',
  NotificationSettings = 'notification-settings',
  ActivationNotifications = 'activation-notifications',
  EnvironmentVisibility = 'environment-visibility',
  AgreementSetup = 'agreement-setup',
  AgreementDetails = 'agreement-details',
  Summary = 'summary',
}
